import { Grid } from '@mui/material';
import React from 'react';
import DsPaymentFilters from './Components/DsPaymentLink/Filters';
import DsPaymentLinkTable from './Components/DsPaymentLink/DataTable';
import { useState } from 'react';
import SnackBar from './Components/General/SnackBar';
import { GetListForTm } from 'API/DsPaymentLink/api';
import { useEffect } from 'react';
import BackdropLoader from './Components/General/Loader';

const DsPaymentLink = () => {
  const [Data, setData] = useState(null);

  const [FilterData, setFilterData] = useState({ ds_name: '', ds_mobile_number: '' });

  const handleFilterChange = (name, value) => {
    console.log('hit ', name);

    if (name === 'ds_name') {
      if (/^[a-zA-Z ]*$/.test(value)) {
        setFilterData({ ...FilterData, [name]: value });
      }
    } else {
      if (/^[0-9]*$/.test(value)) {
        setFilterData({ ...FilterData, [name]: value });
      }
    }
  };

  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState(null);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleGetRequest = () => {
    GetListForTm(FilterData, 1, setData, handleAlertOpen, setIsLoading);
  };

  const handlePageChange = (event, page) => {
    GetListForTm(FilterData, page, setData, handleAlertOpen, setIsLoading);
  };

  const handleSearch = () => {
    handleGetRequest();
  };

  const handleClear = () => {
    setFilterData({ ds_name: '', ds_mobile_number: '' });
    GetListForTm({ ds_name: '', ds_mobile_number: '' }, 1, setData, handleAlertOpen, setIsLoading);
  };

  useEffect(() => {
    handleGetRequest();
  }, []);

  return (
    <Grid container spacing={2}>
      <SnackBar message={AlertMessage} type={AlertType} open={AlertOpen} handleClose={handleAlertClose} />
      <BackdropLoader open={IsLoading} />
      <Grid item xs={12}>
        <DsPaymentFilters filter={FilterData} handleChange={handleFilterChange} handleClear={handleClear} handleSearch={handleSearch} />
      </Grid>
      <Grid item xs={12}>
        <DsPaymentLinkTable
          IsLoading={IsLoading}
          setIsLoading={setIsLoading}
          data={Data}
          handlePageChange={handlePageChange}
          handleAlertOpen={handleAlertOpen}
          handleGet={handleGetRequest}
        />
      </Grid>
    </Grid>
  );
};

export default DsPaymentLink;
